export enum TreeNodeKeyEnum {
    Favourite = "@MyFavorites",
    MostUsed = "@MostUsed",
}